import React from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

interface JawWrapperProps extends FlexProps {
  children: React.ReactNode;
}

const JawWrapper: React.FC<JawWrapperProps> = ({ children, ...rest }) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      position="relative"
      _after={{
        content: `''`,
        position: "absolute",
        top: 0,
        left: "calc(50% - 0.5px)",
        width: "1px",
        height: "100%",
        background: "#C6DDED"
      }}
      _before={{
        content: `''`,
        position: "absolute",
        left: 0,
        top: "50%",
        width: "100%",
        height: "1px",
        background: "#C6DDED"
      }}
      {...rest}
    >
      {children}
    </Flex>
  );
};

export default JawWrapper;
